(function () {
  function initAivoSection(scope) {
    var root = scope && scope.matches && scope.matches('.aivo') ? scope : (scope ? scope.querySelector('.aivo') : document.querySelector('.aivo'));
    if (!root || root.dataset.aivoInitialized === 'true') return;
    root.dataset.aivoInitialized = 'true';

    var revealNodes = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window && revealNodes.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );

      revealNodes.forEach(function (node) {
        observer.observe(node);
      });
    } else {
      revealNodes.forEach(function (node) {
        node.classList.add('is-visible');
      });
    }

    var parallaxItems = root.querySelectorAll('.aivo-parallax');
    if (parallaxItems.length && !window.__aivoParallaxBound) {
      window.__aivoParallaxBound = true;
      window.addEventListener(
        'scroll',
        function () {
          var y = Math.min(window.scrollY * 0.08, 20);
          parallaxItems.forEach(function (img) {
            img.style.transform = 'translateY(' + y * -1 + 'px)';
          });
        },
        { passive: true }
      );
    }

    var modal = root.querySelector('[data-aivo-modal]');
    var openNodes = root.querySelectorAll('[data-aivo-open-modal]');
    var closeNodes = root.querySelectorAll('[data-aivo-close-modal]');

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    openNodes.forEach(function (node) {
      node.addEventListener('click', openModal);
    });

    closeNodes.forEach(function (node) {
      node.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });

    var productJsonNode = root.querySelector('[data-aivo-product-json]');
    var productData = null;

    if (productJsonNode) {
      try {
        productData = JSON.parse(productJsonNode.textContent);
      } catch (e) {
        productData = null;
      }
    }

    function formatMoneyFromVariant(variant) {
      if (!variant || typeof variant.price !== 'number') return '';
      var value = variant.price / 100;
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    if (productData && productData.variants && productData.variants.length) {
      var forms = root.querySelectorAll('[data-aivo-product-form]');

      forms.forEach(function (form) {
        var variantInput = form.querySelector('[data-aivo-variant-id]');
        var optionSelects = form.querySelectorAll('[data-aivo-option-index]');
        var shell = form.closest('.aivo__buy-shell');
        var priceNode = shell ? shell.querySelector('[data-aivo-price]') : null;

        function getSelectedVariant() {
          var selectedValues = [];
          optionSelects.forEach(function (select) {
            selectedValues.push(select.value);
          });

          for (var i = 0; i < productData.variants.length; i++) {
            var variant = productData.variants[i];
            var matched = true;

            for (var j = 0; j < selectedValues.length; j++) {
              if (variant.options[j] !== selectedValues[j]) {
                matched = false;
                break;
              }
            }

            if (matched) return variant;
          }

          return null;
        }

        function syncVariant() {
          var variant = getSelectedVariant();
          if (!variant) return;
          if (variantInput) variantInput.value = variant.id;
          if (priceNode) priceNode.textContent = formatMoneyFromVariant(variant);
        }

        optionSelects.forEach(function (select) {
          select.addEventListener('change', syncVariant);
        });

        syncVariant();
      });
    }

    var ajaxForms = root.querySelectorAll('[data-aivo-ajax-form]');
    ajaxForms.forEach(function (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();

        var submitButton = form.querySelector('[data-aivo-submit]');
        var originalLabel = submitButton ? submitButton.textContent : '';
        var instantRestore = true;

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Processando...';
        }

        try {
          var formData = new FormData(form);
          var response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json'
            },
            body: formData
          });

          if (!response.ok) {
            throw new Error('Erro ao adicionar ao carrinho');
          }

          if (form.hasAttribute('data-aivo-checkout')) {
            window.location.href = '/checkout';
            return;
          }

          if (submitButton) {
            instantRestore = false;
            submitButton.textContent = 'Adicionado ao carrinho';
            setTimeout(function () {
              submitButton.disabled = false;
              submitButton.textContent = originalLabel;
            }, 1200);
          }
        } catch (error) {
          window.alert('Não foi possível adicionar ao carrinho. Tente novamente.');
        } finally {
          if (submitButton && instantRestore) {
            submitButton.disabled = false;
            submitButton.textContent = originalLabel;
          }
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.aivo').forEach(function (node) {
      initAivoSection(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAivoSection(event.target);
  });
})();